import React, { FC, useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { SidebarWrapper } from 'modules/settingsContainer/SideBarWrapper';
import { loadSourceFileStatusAction, loadSourcesAction, loadSourcesActiveLoadingAction } from 'store/reducers/sources/actions';
import { useAppDispatch } from 'store';
import { useParams } from 'react-router-dom';
import { ProjectIdParam } from 'constants/Routes';
import { getShowSidebar, getSourcesActiveLoading } from 'store/reducers/sources/getters';
import { changeShowSidebar } from 'store/reducers/sources';
import { closeWizardModalAction, openWizardModalTypedAction } from 'store/reducers/modals/actions';
import { stepDataList } from 'components/console/elements/sideBar/WizardSourceModalType/constants';
import { useLongPolling } from 'utils/hooks/useLongPolling';
import { useTaskStatuses } from 'components/console/elements/hooks/useTaskStatuses';
import { SourcesConnection } from '../SourcesConnection';

const Sidebar: FC = () => {
  const dispatch = useAppDispatch();
  const { projectId } = useParams<ProjectIdParam>();
  const sourcesActiveLoadingData = useSelector(getSourcesActiveLoading);

  const fetchStatus = useCallback(
    (taskId: string) => dispatch(loadSourceFileStatusAction(taskId)).unwrap(),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  const loadingStatuses = useTaskStatuses({ tasks: sourcesActiveLoadingData, fetchStatus });

  const isShowSidebar = useSelector(getShowSidebar);
  useLongPolling({ intervalCallback: () => dispatch(loadSourcesActiveLoadingAction()), delay: 10000 });

  useEffect(() => {
    if (projectId) {
      dispatch(loadSourcesAction(projectId));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [projectId]);

  const toggleShowSetting = useCallback(() => dispatch(changeShowSidebar()), [dispatch]);

  const onCloseSourceTypeWizard = () => dispatch(closeWizardModalAction());

  const onOpenAddSource = useCallback(() => {
    dispatch(
      openWizardModalTypedAction({
        stepDataList: stepDataList,
        defaultTitle: 'Новое подключение',
        firstStepComponent: 'sources',
        onClose: onCloseSourceTypeWizard,
        projectId,
      }),
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onCloseSourceTypeWizard, projectId]);

  return (
    <SidebarWrapper secondTitle="Все" onClick={onOpenAddSource} isShowSidebar={isShowSidebar} onOpenSidebar={toggleShowSetting}>
      <SourcesConnection loadingStatuses={loadingStatuses} />
    </SidebarWrapper>
  );
};

export default Sidebar;
